module.exports = __webpack_public_path__ + "static/media/image-preview-chat-mo.b2da4f55.png";